/**
 *
 * @type {{NAME: string, SESSION: string, CLOSE: string, FS: string, FS_BUTTON: string, FAVORITE: string, TOGGLES: string, CHECKBOX: string, REAL: string, ANONYMOUS: string, LOGIN: string, CLOCK: string}}
 */
const ELEMENTS = {
    NAME: '.cgp-navbar-game-name',
    SESSION: '.cgp-navbar-game-session',
    CLOSE: '.cgp-navbar-game-close',
    CLOSE_BUTTON: '.game-panel-close-btn',
    FS: '.cgp-navbar-game-fullscreen',
    FS_BUTTON: '.cgp-navbar-game-fullscreen-btn',
    FAVORITE: '.cgp-navbar-game-favorite',
    TOGGLES: '.cgp-navbar-gamemode-toggles',
    SWITCH_GAME_MODE: '.cgp-switch-gamemode',
    CHECKBOX: '.cgp-switch-gamemode-checkbox',
    REAL: '.cgp-switch-real',
    ANONYMOUS: '.cgp-switch-anonymous',
    LOGIN: '.cgp-navbar-login',
    CLOCK: '.cgp-navbar-clock',
    SESSION_TIMER: '.cgp-navbar-session-timer',
    TOGGLE_CIRCLE: '.cgp-switch-icon',
    CHECKBOX_LABEL: '.cgp-checkbox-label',
    TOGGLE_REAL_TEXT: '.cgp-switch-real',
    TOGGLE_ANNONYMOUS_TEXT: '.cgp-switch-anonymous',
    GAME_FRAME_BG_LEFT: '.cgp-game-frame-bg-left',
    GAME_FRAME_BG_RIGHT: '.cgp-game-frame-bg-right',
    NO_TOGGLE: 'cgp-navbar-no-toggle',
    RESPONSIBLE_GAME_ICONS: '.cgp-navbar-resp-game-icons'
};


/**
 *
 * @type {{CATEGORY: {ANONYMOUS: string, REAL: string}, ACTION: {ANONYMOUS: string, REAL: string}}}
 */
const ANALYTICS = {
    CATEGORY: {
        ANONYMOUS: 'Client_GameFrame_Anonymous',
        REAL: 'Client_GameFrame_Real'
    },
    ACTION: {
        ANONYMOUS: 'ToggleAnonymous',
        REAL: 'ToggleRealMoney',
        FS: 'FullScreen',
        GAME_NAME: 'GameName',
        SESSION_ID: 'SessionID',
        CLOSE: 'CloseClick',
        RG: 'RG',
        TIME: 'Time'
    }
};


const GAME_SOURCE = {
    CHALLENGES: 'CHALLENGES'
}


const FP_MESSAGE_DATA = {
    CHALLENGES: {
        content: 'mdp_game_frame_open_fp_from_challenges_content',
        ctaOK: 'mdp_game_frame_open_fp_from_challenges_cta_ok',
        ctaCancel: 'mdp_game_frame_open_fp_from_challenges_cta_cancel',
        analytics: {
            ctaOK: {
                category: "GF_FPChallenge_popup",
                action: "OK_ChallengeFP_Button",
                label: "CTA_OK_ChallengeFP"
            },
            ctaCancel: {
                category: "GF_FPChallenge_popup",
                action: "Cancel_ChallengeFP_Button",
                label: "CTA_Cancel_ChallengeFP"
            },
            close: {}
        }
    }
};

const RESPONSIBLE_GAMBLING_VIEW = {
    WINDOW: 0,
    IFRAME: 1,
    REDIRECT: 2
};

export {ELEMENTS, ANALYTICS, FP_MESSAGE_DATA, GAME_SOURCE, RESPONSIBLE_GAMBLING_VIEW};